module.exports = __webpack_public_path__ + "img/12.e196b3d.webp";